import React, { Component } from 'react';
import { Formik } from 'formik';

import { Button, Col, Form, FormFeedback, FormGroup, Label, Input,  Row, Card, CardBody,CardHeader} from 'reactstrap';
import * as Yup from 'yup';
import Select from 'react-select'
import { industry } from '../../common/const'
import Postman from '../../utils/service'
const urlRegExp = /^(?:(ftp|http|https)?:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}$/gi;

 ///^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/
const IndustryList = industry.map(item=>({value:item, label:item}))

class AddCompanyForm extends Component {

  ValidationSchema = Yup.object().shape({
    company_name: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    url: Yup.string()
      // .matches(urlRegExp, 'Url is not valid')
      .required('Required'),
    linkedin: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    city: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    state: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!'),
    country: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'), 
    // phone: Yup.string()
    //   .matches(phoneRegExp, 'Phone number is not valid')
    //   .required('Required'), 
    // email: Yup.string()
    //   .email('Invalid email')
    //   .required('Required'),      
    Competitor_1: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    Competitor_2: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),     
    bio: Yup.string()
      .min(2, 'Too Short!')
      .required('Required'),                                                 
  });
  constructor(props){
    super(props)
    this.state = {
      selectedIndustry: null,
      industryError: 'null',
      error: null,
      toastManager: props.toastManager
    }
  }
  handleIndustryChange = (selectedIndustry) => {
    this.setState({ selectedIndustry });
  }

  onSubmit = (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
    const industry = this.state.selectedIndustry
    if (industry == null) this.setState({industryError:'Select industry!'})
    const company ={...{Industry: industry.value}, ...values}
    const token = this.props.token
    Postman.addCompany({company, token})
    .then((res)=>{
        this.props.toastManager.add('Successfully Added', {
          appearance: 'success',
          autoDismiss: true,
        })
        this.props.toastManager.add('Successfully Added', {
          appearance: 'success',
          autoDismiss: true,
        })     
      }
    )
    .catch((error)=>{
      status = error.response.status
      console.log('error:', error.response)
      if (status==409) {
        this.props.toastManager.add('Already Added', {
          appearance: 'error',
          autoDismiss: true,
        })
        this.props.toastManager.add('Already Added', {
          appearance: 'error',
          autoDismiss: true,
        })
      }

      else if(status==401) {
        this.props.toastManager.add('Invalid Token', {
          appearance: 'error',
          autoDismiss: true,
        })        
        this.props.toastManager.add('Invalid Token', {
          appearance: 'error',
          autoDismiss: true,
        })        
      }        
      // setStatus({success: false})
      // setSubmitting(false)
      // setErrors({submit: error.message})
    })
 }

  render (){
    const { selectedIndustry } = this.state;

    return (
  <div style={{marginLeft: 0}}>
    <Formik
      initialValues={{
        company_name: '',
        url: '',
        linkedin: '',
        city: '',
        state: '',
        country: '',
        Competitor_1: '',
        Competitor_2: '',
        bio: '',
      }}
     validationSchema={this.ValidationSchema}
      onSubmit={this.onSubmit}
    >
      {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched}) => (
          <Form onSubmit={handleSubmit} noValidate name='subscribeForm' style={{width:"100%"}}>
            <Row>
              <Col lg={6}>
                <FormGroup >
                <Label>Company Name<span className="text-danger"> *</span></Label>
                <Input type="text"
                        name="company_name"
                        id="company_name"
                        placeholder=""
                        valid={!errors.company_name&&values.company_name!=''}
                        invalid={touched.company_name && !!errors.company_name}
                        autoFocus={false}
                        onChange={handleChange}
                        required
                        value={values.company_name} />
                <FormFeedback>{errors.company_name}</FormFeedback>
              </FormGroup>       
                <FormGroup >
                  <Label>Url<span className="text-danger"> *</span></Label>
                  <Input type="text"
                          name="url"
                          id="url"
                          valid={!errors.url&&values.url!=''}
                          placeholder="domain.com"
                          invalid={touched.url && !!errors.url}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.url} />
                  <FormFeedback>{errors.url}</FormFeedback>
                </FormGroup> 
                <FormGroup >
                <Label>Company Linkedin URL<span className="text-danger"> *</span></Label>
                  <Input type="text"
                          name="linkedin"
                          id="linkedin"
                          valid={!errors.linkedin&&values.linkedin!=''}
                          placeholder=""
                          invalid={touched.linkedin && !!errors.linkedin}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.linkedin} />
                  <FormFeedback>{errors.linkedin}</FormFeedback>
                </FormGroup> 
                <FormGroup >
                <Label>City<span className="text-danger"> *</span></Label>
                  <Input type="text"
                          name="city"
                          id="city"
                          placeholder=""
                          valid={!errors.city&&values.city!=''}
                          invalid={touched.city && !!errors.city}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.city} />
                  <FormFeedback>{errors.city}</FormFeedback>
                </FormGroup> 
                <FormGroup >
                <Label>State</Label>
                  <Input type="text"
                          name="state"
                          id="state"
                          placeholder=""
                          valid={!errors.state&&values.state!=''}
                          invalid={touched.state && !!errors.state}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.state} />
                  <FormFeedback>{errors.state}</FormFeedback>
                </FormGroup> 
                <FormGroup >
                <Label>Country<span className="text-danger"> *</span></Label>
                  <Input type="text"
                          name="country"
                          id="country"
                          placeholder=""
                          valid={!errors.country&&values.country!=''}
                          invalid={touched.country && !!errors.country}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.country} />
                  <FormFeedback>{errors.country}</FormFeedback>
                </FormGroup> 
              </Col>
              <Col lg={6}>
              <FormGroup >
                <Label>Industry<span className="text-danger"> *</span></Label>
                  <Select
                    value={selectedIndustry}
                    onChange={this.handleIndustryChange}
                    options={IndustryList}
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                  />       
                  <FormFeedback>{this.state.industryError}</FormFeedback>           
                </FormGroup>               
                <FormGroup >
                <Label>Competitor 1<span className="text-danger"> *</span></Label>
                  <Input type="text"
                          name="Competitor_1"
                          id="Competitor_1"
                          placeholder=""
                          valid={!errors.Competitor_1&&values.Competitor_1!=''}
                          invalid={touched.Competitor_1 && !!errors.Competitor_1}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.Competitor_1} />
                  <FormFeedback>{errors.Competitor_1}</FormFeedback>
                </FormGroup>             
                <FormGroup >
                <Label>Competitor 2<span className="text-danger"> *</span></Label>
                  <Input type="text"
                          name="Competitor_2"
                          id="Competitor_2"
                          placeholder=""
                          valid={!errors.Competitor_2&&values.Competitor_2!=''}
                          invalid={touched.Competitor_2 && !!errors.Competitor_2}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.Competitor_2} />
                  <FormFeedback>{errors.Competitor_2}</FormFeedback>
                </FormGroup> 
                <FormGroup >
                <Label>Discription<span className="text-danger"> *</span></Label>
                  <Input type="textarea"
                          name="bio"
                          id="bio"
                          placeholder=""
                          valid={!errors.bio&&values.bio!=''}
                          invalid={touched.bio && !!errors.bio}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          rows={8}
                          value={values.bio} />
                  <FormFeedback>{errors.bio}</FormFeedback>
                </FormGroup> 
              </Col>
            </Row>
            <FormGroup style={{float:"right"}}>
              <Button 
                // onClick={() => this.touchAll(setTouched, errors)} 
                style={{width: 150}}
                type="submit" color="success" className="mr-1">Add</Button>
            </FormGroup>   
        </Form>
      )}
    </Formik>
  </div>
);
    }
};

//const AddCompanyFormWithToast = withToastManager(AddCompanyForm);
class AddCompany extends Component {
  constructor(props){
    super(props)
    this.state={
      token: props.match.params.token
    }
  }
  componentDidMount() {
    Postman.subscribeToMailchimp({token: this.props.match.params.token})
  }
  
  render() {

    return (
      <div className="animated fadeIn" style={{height:"100%"}}>
      <Card style={{height:"100%", margin:0}}>
        <CardHeader><h1>Add Company</h1></CardHeader>  
        
        <CardBody style={{padding: 30, paddingTop:20}}>
          <AddCompanyForm token={this.state.token}/>
        </CardBody>
      </Card>
      </div>
    );
  }
}

export default AddCompany;



// WEBPACK FOOTER //
// ./client/src/views/AddCompany/index.js